// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__13ReE","content":"LoadingAlert_content__TLJcP"};